
import { Component, OnInit } from '@angular/core';
import { SearchServicesComponent } from './dummy/search-services.component';
import { ListServicesComponent } from './dummy/list-services.component';
import { ServicesService } from "../../../injections/services.service";
import * as moment from 'moment';
import {Router, ActivatedRoute} from "@angular/router";
import { LoaderService } from '../../../common/loadingBar/loader.service';

@Component({
  templateUrl: '../templates/main-services.html'
})
export class MainServicesComponent implements OnInit{

    public services: any = [];
    public filter: Array<string> = [];
    public filterAssigned:any = null;
    public cleanFilter: boolean = false;
    public search = null;
    public showModal: boolean = false;
    public commentsResume: object = {
      commentData: [],
      serviceData: []
    };
    constructor(
      private servicesService: ServicesService, 
      private _router: Router
    ){}

    
    public setFilterPipe(event){
      this.filter = event;
    }

    public setFilterAssigned(event){
      this.filterAssigned = event;
    }

    public changeDateServices(event){
      this.services = [];
      this.getServices(event.formatDate, event.formatDate); 
    }

    public showModalComments(event: any) {
      this.getResumeComments(event);
    }

    public displayModal(event){
      //console.log(event);
      if(event["action"] == "close"){
        this.showModal = false;
      }else{
        this.showModal = true;
      }
    }

    public clearSearch() {
        this.search = null;
        this.services = [];
        //var today = moment().format("YYYY-MM-DD");
    }

    public searchServices(filters: object) {
      this.emptyFilters();
      this.search = filters;
      this.services = [];
      this.servicesService.searchServices(filters)
      .subscribe(data => {
        this.services.push(data);
      });

    }

    public getServices(dateMin: string, dateMax) {
      if(dateMin != ""){
        this.emptyFilters();
      }
        this.servicesService.getServices(dateMin, dateMax)
      .subscribe(data => {
        this.services.push(data);
      });
    }
    
    public emptyFilters(){
      this.filter = null;
      this.filterAssigned = null;
      this.cleanFilter = !this.cleanFilter;
    }

    private getResumeComments(object: object){
      this.servicesService.getCommentsResume(object["id_service"]).subscribe(result => {
        this.commentsResume["commentData"] = result;
        this.commentsResume["serviceData"] = object;
        this.displayModal("open");
      });
    }

    ngOnInit(){
        var today = moment().format("YYYY-MM-DD");
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/main-services.component.ts